import config from '../..//services/config';
import BaseDrawingObject from "./baseDrawingObject";

class Arc extends BaseDrawingObject {
    constructor(options) {
        let { startX, startY, radius, startAngle, sweep, antiClockwise, layerNumber, blockName, objNumSeqNum, closedIndicator, reverseAngleSigns, pixiAntiClockwise } = options
        super();
        this.centre = { x: startX, y: startY };

        this.radius = radius;
        this.startAngle = getRadians(startAngle);
        //if (this.startAngle < 0) {
        //    this.startAngle = Math.PI + this.startAngle;
        //}
        //else {
        //    this.startAngle = startAngle;
        //}
        if (antiClockwise === true) {
            this.endAngle = this.startAngle + getRadians(sweep);
        } else {
            this.endAngle = getRadians(sweep) - this.startAngle;
        }
        this.reverseAngleSigns = reverseAngleSigns;
        this.getStartAngleToUse = function () {
            if(this.reverseAngleSigns) {
                return -this.startAngle;
            }
            return this.startAngle;
        }

        this.getEndAngleToUse = function () {
            if(this.reverseAngleSigns) {
                return -this.endAngle;
            }
            return this.endAngle;
        }
        this.dashed = false;
        this.startPoint = getArcStartPoint(this.startAngle, this.radius, this.centre, this.reverseAngleSigns);
        this.endPoint = getArcStartPoint(this.endAngle, this.radius, this.centre, this.reverseAngleSigns);
        this.antiClockwise = antiClockwise;
        this.pixiAntiClockwise = pixiAntiClockwise;
        //this.convertStartAngle = startAngle * Math.PI / 180;
        //this.convertEndAngle = sweep * Math.PI / 180;
        this.layerNumber = layerNumber;
        this.blockName = blockName;
        this.objNumSeqNum = objNumSeqNum;
        this.closedIndicator = closedIndicator;
        this.type = 'arc';
        if (objNumSeqNum !== undefined) {
            this.objectNumber = parseInt(objNumSeqNum.substring(0, objNumSeqNum.lastIndexOf("_"))),
            this.sequenceNumber = parseInt(objNumSeqNum.substring(objNumSeqNum.lastIndexOf("_") + 1));
        }
        
        // this.drawingGroupName = config.CHASSIS_OBJECT_TYPES.VEHICLE;
        // function setDrawingGroupName(group) {
        //     this.drawingGroupName = group;
        //     return this;
        // }
        // self.setDrawingGroupName = setDrawingGroupName;
        
        function getArcStartPoint(startAngle, radius, centrePoint, reverseAngleSigns) {
            
            // var startX, startY;

            // // startAngle = -startAngle;

            // if (startAngle >= 0 && startAngle < getRadians(90)) {
            //     //bottom right
            //     startX = centrePoint.x + radius * Math.abs(Math.cos(startAngle));
            //     startY = centrePoint.y + radius * Math.abs(Math.sin(startAngle));
            // } else if (startAngle >= getRadians(90) && startAngle < getRadians(180)) {
            //     //bottom left
            //     startX = centrePoint.x - radius * Math.abs(Math.cos(startAngle));
            //     startY = centrePoint.y + radius * Math.abs(Math.sin(startAngle));
            // } else if (startAngle >= getRadians(180) && startAngle < getRadians(270)) {
            //     // top left
            //     startX = centrePoint.x - radius * Math.abs(Math.cos(startAngle));
            //     startY = centrePoint.y - radius * Math.abs(Math.sin(startAngle));
            // } else if (startAngle >= getRadians(270) && startAngle <= getRadians(360)) {
            //     //top right
            //     startX = centrePoint.x + radius * Math.abs(Math.cos(startAngle));
            //     startY = centrePoint.y - radius * Math.abs(Math.sin(startAngle));
            // }
            
            // return { x: startX, y: startY };
            // const angle = -startAngle;
            // return {
            //     x: centrePoint.x + radius * Math.cos(angle),
            //     y: centrePoint.y + radius * Math.sin(angle)
            // };
            if(reverseAngleSigns) {
                startAngle = -startAngle;
            }
            return {
                x: centrePoint.x + radius * Math.cos(startAngle),
                y: centrePoint.y + radius * Math.sin(startAngle)
            };
        }

        

        function getRadians(angleDegrees) {
            var angleRadian =  (Math.PI / 180) * angleDegrees;
            if (angleRadian < 0) angleRadian += 2 * Math.PI;
            return angleRadian;
            //Return Math.PI * angleInDegrees / 180.0
        }

        this.setCentre = function(centre) {
            this.centre = { x: centre.x, y: centre.y };
            this.startPoint = getArcStartPoint(this.startAngle, this.radius, this.centre, this.reverseAngleSigns);
            this.endPoint = getArcStartPoint(this.endAngle, this.radius, this.centre, this.reverseAngleSigns);
        }

        this.setDashed = function(dashedBool) {
            this.dashed = dashedBool;
        }

        this.setColour = function (colour) {
            this.colour = colour;
        }

        this.setFillColour = function (colour) {
            this.fillColour = colour;

            return this;
        }

        this.refresh = function () {
            
            this.startAngle = getRadians(this.startAngle);
            //if (this.startAngle < 0) {
            //    this.startAngle = Math.PI + this.startAngle;
            //}
            //else {
            //    this.startAngle = startAngle;
            //}
            if (this.antiClockwise === true) {
                this.endAngle = this.startAngle + getRadians(sweep);
            } else {
                this.endAngle = getRadians(sweep) - this.startAngle;
            }
            
            this.startPoint = getArcStartPoint(this.startAngle, this.radius, this.centre, this.reverseAngleSigns);
            this.endPoint = getArcStartPoint(this.endAngle, this.radius, this.centre, this.reverseAngleSigns);
            
        }

        this.bypassHitAreaSort = false;
        this.setBypassHitAreaSort = function (newValue) {
            this.bypassHitAreaSort = newValue;
        }
        
        this.setDrawingOrder = function (newValue) {
            this.drawingOrder = newValue;
        }

        // this.setBringToFront = function (newValue) {
        //     this.bringToFront = newValue;
        // }

        // this.setLineWidth = function (newValue) {
        //     this.lineWidth = newValue;
        // }
    }
}

export default Arc;

       
